
import CryptoJS from 'crypto-js'

// const key = CryptoJS.enc.Utf8.parse('79293149emvclkfg') // 十六位十六进制数作为密钥
// const iv = CryptoJS.enc.Utf8.parse('79293149emvclkfg') // 十六位十六进制数作为密钥偏移量

export default {
  // 随机生成指定数量的16进制key
  generatekey (num) {
    let library = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let key = ''
    for (var i = 0; i < num; i++) {
      let randomPoz = Math.floor(Math.random() * library.length)
      key += library.substring(randomPoz, randomPoz + 1)
    }
    return key
  },

  // 解密
  decrypt (word, keyStr) {
    keyStr = keyStr || 'abcdsxyzhkj12345'
    var key = CryptoJS.enc.Utf8.parse(keyStr)
    var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  }

}

// AES加密
export function encrypt (word, keyStr) {
  // console.log('keyStr', keyStr)
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let iv = CryptoJS.enc.Utf8.parse(keyStr) // 十六位十六进制数作为密钥偏移量
  let encrypted = CryptoJS.AES.encrypt(srcs, iv, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}

// md5加密
export function md5crypt (signStr) {
  return CryptoJS.MD5(signStr).toString()
}

export function paramsToSring (obj) {
  let result = ''
  let item
  for (item in obj) {
    if (obj[item] && String(obj[item])) {
      result += `&${item}=${obj[item]}`
    }
  }
  if (result) {
    result = '' + result.slice(1)
  }
  return result
}

export function getRandomSixDigit () {
  let code = ''
  for (var i = 0; i < 6; i++) {
    code += parseInt(Math.random() * 10)
  }

  return code
}
